import {
  Language,
  STOCKHOLM_TIME_ZONE,
  TranslationMessageTree,
} from "@repo/common"
import "@repo/ui/lib/i18n-config"
import React from "react"
import { IntlProvider } from "use-intl"

/**
 * use-intl's provider for apps that don't depend on use-intl themselves (the
 * admin app), so the @repo/ui components they render can call
 * `useTranslations()`.
 */
export const TranslationIntlProvider = ({
  language,
  messages,
  children,
}: {
  language: Language
  messages: TranslationMessageTree
  children: React.ReactNode
}) => (
  <IntlProvider
    locale={language}
    messages={messages}
    timeZone={STOCKHOLM_TIME_ZONE}
  >
    {children}
  </IntlProvider>
)
